import React from 'react';
import {
  Control,
  Controller,
  ControllerProps,
  FieldError
} from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

import { useStyles } from './styles';

type IControllerProps = Omit<ControllerProps, 'render' | 'name'>;

type TextInputProps = {
  errorMessageCustom?: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  controllerProps?: IControllerProps;
} & TextFieldProps;

function maskClockValue(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 4);
  if (digits.length === 0) return '';

  let h1 = digits[0];
  if (h1 > '1') h1 = '1';

  let result = h1;
  if (digits.length >= 2) {
    let h2 = digits[1];
    if (h1 === '1' && h2 > '2') h2 = '2';
    if (h1 === '0' && h2 > '9') h2 = '9';
    result += h2;
  }
  if (digits.length >= 3) {
    let m1 = digits[2];
    if (m1 > '5') m1 = '5';
    result = result + ':' + m1;
  }
  if (digits.length >= 4) {
    result += digits[3];
  }
  return result;
}

const KogInputClockMask = ({
  name,
  control,
  errorMessageCustom,
  controllerProps,
  ...props
}: TextInputProps) => {
  const styles = useStyles({});
  const renderErrorMessages = (error: FieldError | undefined) => {
    if (!error) return null;
    switch (error.type) {
      case 'required':
        return `${props.label || 'This Field'} is required`;
      case 'minLength':
        return '';
      default:
        return error.message;
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      {...controllerProps}
      render={({ field: { ref, onChange, value, ...field }, fieldState: { error } }) => (
        <TextField
          fullWidth
          required={Boolean(controllerProps?.rules?.required)}
          size="small"
          variant="filled"
          error={!!error}
          helperText={errorMessageCustom || renderErrorMessages(error)}
          className={styles.inputText}
          inputProps={{
            maxLength: 5,
            placeholder: '__:__',
            ...(props.inputProps || {})
          }}
          inputRef={ref}
          value={value || ''}
          onChange={(e) => {
            const masked = maskClockValue(e.target.value);
            onChange(masked);
          }}
          {...field}
          {...props}
        />
      )}
    />
  );
};

export default KogInputClockMask;
